import React from 'react'

export const Theme = React.createContext({
  title: '',
  changeTheme: (name: string) => {},
});
